import { module as Module } from 'modujs'

export default class extends Module {
  constructor(m) {
    super(m)

    this.video = this.$('video')[0]
  }

  init() {
    if (!this.video) return
    this.video.play()
  }

  update() {
    if (!this.video) return
    this.video.play()
  }

  destroy() {
    if (!this.video) return
    this.video.pause()
  }
}
